var ip = window.location.hostname;
var protocol = window.location.protocol == "https:" ? "https" : "http";
// var baseURL  = window.location.origin;
export const API_URL = `https://server.bamboo.rizq.no/`;
// export const BASE_URL = `${protocol}://${ip}:3001/`;
export const BASE_URL = `https://server.bamboo.rizq.no/`;
// export const BASE_URL_LOCAL = `http://192.168.18.8:3001/`;
export const GoogleMapsAPI = ''; 
export const priceunit = "kr ";
